import z from "zod";

import { BillingDetails, Price, Product } from "@/shared/domains";
import {
  INTAKE_STATUS,
  SUBSCRIPTION_STATUS,
  SUBSCRIPTION_VENDOR,
} from "./enums";

const SubscriptionProduct = z.lazy(() =>
  Product.extend({
    legacy: z.boolean(),
    branded: z.boolean(),
    price: Price.omit({ tags: true }),
  }).omit({ tags: true, prices: true }),
);

export const Subscription = z.object({
  id: z.number(),
  status: z.enum(SUBSCRIPTION_STATUS),
  intakeFormCompleted: z.boolean(),
  hasPendingFollowUp: z.boolean(),
  vendor: z.enum(SUBSCRIPTION_VENDOR),
  flowStatus: z.enum(INTAKE_STATUS).nullable(),
  currentProduct: SubscriptionProduct,
  nextPeriodProduct: SubscriptionProduct.nullable(),
  requestedProduct: SubscriptionProduct.nullable(),
  isChangeMandatory: z.boolean().nullish(),
  cancelAt: z.iso.datetime({ offset: true }).nullable(),
  isUpgradable: z.boolean().nullish(),
});
export type Subscription = z.infer<typeof Subscription>;

export const SubscriptionWithBillingDetails = Subscription.extend({
  get billingDetails() {
    return BillingDetails;
  },
});
export type SubscriptionWithBillingDetails = z.infer<
  typeof SubscriptionWithBillingDetails
>;
